<template>
    <div class="map-home">
        <MapHomeNav />
        <router-view />
    </div>
</template>

<script>

import { useMapStore } from '@/stores/mapStore';
import MapHomeNav from '@/components/navigation/MapHomeNav.vue';

import { useRouter } from 'vue-router';

export default {
    name: 'MapHome',
    components: {
        MapHomeNav
    },
    data() {
        return {
            router: null,
            mapStore: null,
        }
    },
    mounted() {
        this.router = useRouter();
        this.mapStore = useMapStore();

        const customParam = localStorage.getItem('token');
        if (!customParam) {
            this.router.push({ path: '/login' });
        }
        this.mapStore.loadCodeList();

        
        // else {
        //     this.mapStore.loadCodeList();
        // }
    },
    methods: {

    }
}
</script>

<style scoped>
.map-home {
    height: 100%;
    width: 100%;
    display: flex;
}
</style>